/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { GetTuitionDiscountResponse } from './GetTuitionDiscountResponse';
import {
    GetTuitionDiscountResponseFromJSON,
    GetTuitionDiscountResponseFromJSONTyped,
    GetTuitionDiscountResponseToJSON,
    GetTuitionDiscountResponseToJSONTyped,
} from './GetTuitionDiscountResponse';
import type { BalanceUnitStatementEntryDebit } from './BalanceUnitStatementEntryDebit';
import {
    BalanceUnitStatementEntryDebitFromJSON,
    BalanceUnitStatementEntryDebitFromJSONTyped,
    BalanceUnitStatementEntryDebitToJSON,
    BalanceUnitStatementEntryDebitToJSONTyped,
} from './BalanceUnitStatementEntryDebit';
import type { TuitionType } from './TuitionType';
import {
    TuitionTypeFromJSON,
    TuitionTypeFromJSONTyped,
    TuitionTypeToJSON,
    TuitionTypeToJSONTyped,
} from './TuitionType';
import type { RegistrationMode } from './RegistrationMode';
import {
    RegistrationModeFromJSON,
    RegistrationModeFromJSONTyped,
    RegistrationModeToJSON,
    RegistrationModeToJSONTyped,
} from './RegistrationMode';
import type { RegistrationFeeType } from './RegistrationFeeType';
import {
    RegistrationFeeTypeFromJSON,
    RegistrationFeeTypeFromJSONTyped,
    RegistrationFeeTypeToJSON,
    RegistrationFeeTypeToJSONTyped,
} from './RegistrationFeeType';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetSeasonResponse
 */
export interface GetSeasonResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetSeasonResponse
     */
    seasonId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetSeasonResponse
     */
    name: string;
    /**
     * 
     * @type {any}
     * @memberof GetSeasonResponse
     */
    seasonStartDate: any | null;
    /**
     * 
     * @type {any}
     * @memberof GetSeasonResponse
     */
    seasonEndDate: any | null;
    /**
     * 
     * @type {any}
     * @memberof GetSeasonResponse
     */
    onlineRegistrationStartDate: any | null;
    /**
     * 
     * @type {any}
     * @memberof GetSeasonResponse
     */
    onlineRegistrationEndDate: any | null;
    /**
     * 
     * @type {any}
     * @memberof GetSeasonResponse
     */
    ageCutOfDate: any | null;
    /**
     * 
     * @type {number}
     * @memberof GetSeasonResponse
     */
    additionalFee: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetSeasonResponse
     */
    chargeRegistrationFee: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetSeasonResponse
     */
    registrationFee: number;
    /**
     * 
     * @type {RegistrationMode}
     * @memberof GetSeasonResponse
     */
    registrationMode: RegistrationMode | null;
    /**
     * 
     * @type {RegistrationFeeType}
     * @memberof GetSeasonResponse
     */
    registrationFeeType: RegistrationFeeType | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetSeasonResponse
     */
    hideOnLiveSchedule: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSeasonResponse
     */
    prorateTuition: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSeasonResponse
     */
    isActive: boolean;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof GetSeasonResponse
     */
    tuition: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetSeasonResponse
     */
    isContinuous: boolean | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetSeasonResponse
     */
    tuitionRatePlanId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {Array<GetTuitionDiscountResponse>}
     * @memberof GetSeasonResponse
     */
    tuitionDiscounts: Array<GetTuitionDiscountResponse>;
    /**
     * 
     * @type {TuitionType}
     * @memberof GetSeasonResponse
     */
    tuitionType?: TuitionType | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetSeasonResponse
     */
    isFeatured?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSeasonResponse
     */
    imageUrl?: string | null;
}



/**
 * Check if a given object implements the GetSeasonResponse interface.
 */
export function instanceOfGetSeasonResponse(value: object): value is GetSeasonResponse {
    if (!('seasonId' in value) || value['seasonId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('seasonStartDate' in value) || value['seasonStartDate'] === undefined) return false;
    if (!('seasonEndDate' in value) || value['seasonEndDate'] === undefined) return false;
    if (!('onlineRegistrationStartDate' in value) || value['onlineRegistrationStartDate'] === undefined) return false;
    if (!('onlineRegistrationEndDate' in value) || value['onlineRegistrationEndDate'] === undefined) return false;
    if (!('ageCutOfDate' in value) || value['ageCutOfDate'] === undefined) return false;
    if (!('additionalFee' in value) || value['additionalFee'] === undefined) return false;
    if (!('chargeRegistrationFee' in value) || value['chargeRegistrationFee'] === undefined) return false;
    if (!('registrationFee' in value) || value['registrationFee'] === undefined) return false;
    if (!('registrationMode' in value) || value['registrationMode'] === undefined) return false;
    if (!('registrationFeeType' in value) || value['registrationFeeType'] === undefined) return false;
    if (!('hideOnLiveSchedule' in value) || value['hideOnLiveSchedule'] === undefined) return false;
    if (!('prorateTuition' in value) || value['prorateTuition'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('tuition' in value) || value['tuition'] === undefined) return false;
    if (!('isContinuous' in value) || value['isContinuous'] === undefined) return false;
    if (!('tuitionRatePlanId' in value) || value['tuitionRatePlanId'] === undefined) return false;
    if (!('tuitionDiscounts' in value) || value['tuitionDiscounts'] === undefined) return false;
    return true;
}

export function GetSeasonResponseFromJSON(json: any): GetSeasonResponse {
    return GetSeasonResponseFromJSONTyped(json, false);
}

export function GetSeasonResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSeasonResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'seasonId': ApiUserTasksGetPageParameterFromJSON(json['seasonId']),
        'name': json['name'],
        'seasonStartDate': json['seasonStartDate'],
        'seasonEndDate': json['seasonEndDate'],
        'onlineRegistrationStartDate': json['onlineRegistrationStartDate'],
        'onlineRegistrationEndDate': json['onlineRegistrationEndDate'],
        'ageCutOfDate': json['ageCutOfDate'],
        'additionalFee': json['additionalFee'],
        'chargeRegistrationFee': json['chargeRegistrationFee'],
        'registrationFee': json['registrationFee'],
        'registrationMode': RegistrationModeFromJSON(json['registrationMode']),
        'registrationFeeType': RegistrationFeeTypeFromJSON(json['registrationFeeType']),
        'hideOnLiveSchedule': json['hideOnLiveSchedule'],
        'prorateTuition': json['prorateTuition'],
        'isActive': json['isActive'],
        'tuition': BalanceUnitStatementEntryDebitFromJSON(json['tuition']),
        'isContinuous': json['isContinuous'],
        'tuitionRatePlanId': ActorActivityRecordActorUserIdFromJSON(json['tuitionRatePlanId']),
        'tuitionDiscounts': ((json['tuitionDiscounts'] as Array<any>).map(GetTuitionDiscountResponseFromJSON)),
        'tuitionType': json['tuitionType'] == null ? undefined : TuitionTypeFromJSON(json['tuitionType']),
        'isFeatured': json['isFeatured'] == null ? undefined : json['isFeatured'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
    };
}

export function GetSeasonResponseToJSON(json: any): GetSeasonResponse {
    return GetSeasonResponseToJSONTyped(json, false);
}

export function GetSeasonResponseToJSONTyped(value?: GetSeasonResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'seasonId': ApiUserTasksGetPageParameterToJSON(value['seasonId']),
        'name': value['name'],
        'seasonStartDate': value['seasonStartDate'],
        'seasonEndDate': value['seasonEndDate'],
        'onlineRegistrationStartDate': value['onlineRegistrationStartDate'],
        'onlineRegistrationEndDate': value['onlineRegistrationEndDate'],
        'ageCutOfDate': value['ageCutOfDate'],
        'additionalFee': value['additionalFee'],
        'chargeRegistrationFee': value['chargeRegistrationFee'],
        'registrationFee': value['registrationFee'],
        'registrationMode': RegistrationModeToJSON(value['registrationMode']),
        'registrationFeeType': RegistrationFeeTypeToJSON(value['registrationFeeType']),
        'hideOnLiveSchedule': value['hideOnLiveSchedule'],
        'prorateTuition': value['prorateTuition'],
        'isActive': value['isActive'],
        'tuition': BalanceUnitStatementEntryDebitToJSON(value['tuition']),
        'isContinuous': value['isContinuous'],
        'tuitionRatePlanId': ActorActivityRecordActorUserIdToJSON(value['tuitionRatePlanId']),
        'tuitionDiscounts': ((value['tuitionDiscounts'] as Array<any>).map(GetTuitionDiscountResponseToJSON)),
        'tuitionType': TuitionTypeToJSON(value['tuitionType']),
        'isFeatured': value['isFeatured'],
        'imageUrl': value['imageUrl'],
    };
}

